import { api } from "@king-ict/eupisi-ui/utils";

import { DocumentDeleteRequest } from "./DocumentDeleteRequest";
import { DocumentUploadRequest } from "./DocumentUploadRequest";

const documentsUrlPrefix: string = "documents";

export const uploadDocument = async (request: DocumentUploadRequest) => {
  var uploadFormData = new FormData();
  uploadFormData.append('Document', request.document);
  uploadFormData.append('DocumentTypeId', request.documentTypeId.toString());  
  if(request.resolutionDocumentTypeId){
    uploadFormData.append('resolutionDocumentTypeId', request.resolutionDocumentTypeId.toString());
  }
  return api.post(
    documentsUrlPrefix,
    uploadFormData
  ) as Promise<number>;
};

export const deleteDocument = async (request: DocumentDeleteRequest) => {
  return api.delete(
    documentsUrlPrefix,
    request
  ) as Promise<void>;
}

export const downloadDocument = async (documentType: number, documentId: number) => {
  var res = api.download(
    `${documentsUrlPrefix}/${documentType}/${documentId}`,
  ) as Promise<any>;
  return res;
}